import { useTranslation } from "react-i18next";
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import * as F from "../../features/admin/utils/Functions";

export default function StatusMultiSelectFilter({
  statusOptions,
  currentStatusValues,
  handleStatusSelectChange,
  testId,
}) {
  const { t } = useTranslation();

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{t("Status")}</InputLabel>
      <Select
        multiple
        value={currentStatusValues}
        onChange={handleStatusSelectChange}
        input={<OutlinedInput label={t("Status")} />}
        SelectDisplayProps={{ ...(testId && { "data-testid": testId }) }}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => {
              const statusOption = statusOptions.find((s) => s.value === value);
              return (
                <Chip
                  key={value}
                  icon={F.getIconByStatus(value)}
                  label={statusOption ? t(statusOption.title) : value}
                  size="small"
                />
              );
            })}
          </Box>
        )}
      >
        {statusOptions.map((s) => (
          <MenuItem key={s.title} value={s.value}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {F.getIconByStatus(s.value)}
              {t(s.title)}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
